import React from 'react';
import { ISupplementListState } from '../../../../types/supplement/supplementsTypes';
import Card from '../../../../muiComponents/Card';
import Tooltip from '../../../../muiComponents/Tooltip';
import DotIcon from '../../../components/DotIcon';
import Grid from '../../../../muiComponents/Grid';
import GridChild from '../../../../muiComponents/GridChild';
import { supplementCardGrid } from '../../../../utils/supplements/supplementUtils';
import Icon from '../../../../muiComponents/Icon';
import SupplierTaxCalculationTypeIcon from '../../taxes/taxTypesIcons/SupplierTaxCalculationTypeIcon';
import SupplierTaxCalculationRuleTypeIcon from '../../taxes/taxTypesIcons/SupplierTaxCalculationRuleTypeIcon';
import { commonIcons } from '../../../../utils/commonVariables/commonIcons';
import useTranslate from '../../../../customHooks/useTranslate';
import routes from '../../../../utils/commonVariables/routes';
import { formatDate, isDateless } from '../../../../utils/formatDates';
import { useSearchParams } from '../../../../customHooks/useSearchParams';
import {
    gridSpacing10,
    gridSpacing20,
} from '../../../../utils/commonVariables/grid';

interface SupplementRowProps {
    supplement: ISupplementListState;
}
const SupplementCard = ({ supplement }: SupplementRowProps) => {
    const translate = useTranslate();

    const linkToHotel = routes.propertyDetail(supplement.IdSupplierHotel);

    const datelessFrom = isDateless(supplement.FromDate);
    const datelessTo = isDateless(supplement.ToDate);

    const { setSearchParam } = useSearchParams({ base64: true });
    const handleCardClick = (idSupplement: string) => {
        setSearchParam('id', idSupplement);
    };

    return (
        <Card
            className='padding20 flex-column gap-20 cursor-pointer'
            onClick={() => handleCardClick(supplement.Id)}
        >
            <div className='flex-column gap-5'>
                <div className='flex flex-between'>
                    <h6 className='text-secondary-700 text-size-16'>
                        {supplement.Name}
                    </h6>
                    <div className='flex gap-20 flex-align-center'>
                        {!datelessFrom || !datelessTo ? (
                            <p>
                                {supplement.FromDate
                                    ? formatDate(supplement.FromDate)
                                    : '--/--/----'}
                                {' - '}
                                {supplement.ToDate
                                    ? formatDate(supplement.ToDate)
                                    : '--/--/----'}
                            </p>
                        ) : (
                            ''
                        )}
                        <Tooltip
                            title={translate(
                                supplement.Enabled ? 'enabled' : 'disabled'
                            )}
                        >
                            <span>
                                <DotIcon truthy={supplement.Enabled} />
                            </span>
                        </Tooltip>
                    </div>
                </div>
                <div className='flex flex-align-start gap-10 width100perc border-color-block padding-block-8 border-radius-5'>
                    <span className='flex-grow'>
                        <Tooltip title={supplement.Description || ''}>
                            <p className='tax__description text-preline'>
                                {supplement.Description || ''}
                            </p>
                        </Tooltip>
                    </span>
                    <div className='flex flex-end gap-10'>
                        <SupplierTaxCalculationTypeIcon
                            entityKey={supplement.SupplierTaxCalculationTypeKey}
                            text={supplement.SupplierTaxCalculationType}
                        />
                        <SupplierTaxCalculationRuleTypeIcon
                            entityKey={
                                supplement.SupplierTaxCalculationRuleTypeKey
                            }
                            type='subject'
                        />
                        <SupplierTaxCalculationRuleTypeIcon
                            entityKey={
                                supplement.SupplierTaxCalculationRuleTypeKey
                            }
                            type='frequency'
                        />
                    </div>
                </div>
            </div>
            <Grid columnSpacing={gridSpacing20} rowSpacing={gridSpacing10}>
                {supplement.IdSupplierHotel ? (
                    <GridChild gridProps={supplementCardGrid}>
                        <Tooltip titleText={'hotel'} placement='top-start'>
                            <div className='flex gap-5'>
                                <Icon iconName={commonIcons.HOTEL} />

                                <Tooltip titleText='navigate_to_hotel_detail'>
                                    <p
                                        className=' link-onhover cursor-pointer'
                                        onClick={e => {
                                            e.stopPropagation();
                                            window.open(
                                                linkToHotel,
                                                linkToHotel
                                            );
                                        }}
                                    >
                                        {supplement.SupplierHotel}
                                    </p>
                                </Tooltip>
                            </div>
                        </Tooltip>
                    </GridChild>
                ) : null}

                {supplement.IdSupplierHotelRoomType ? (
                    <GridChild gridProps={supplementCardGrid}>
                        <Tooltip titleText={'room'} placement='top-start'>
                            <div className='flex gap-5'>
                                <Icon iconName={commonIcons.ROOM} />
                                <p>{supplement.SupplierHotelRoomType}</p>
                            </div>
                        </Tooltip>
                    </GridChild>
                ) : null}
                {supplement.IdSupplierHotelMealPlan ? (
                    <GridChild gridProps={supplementCardGrid}>
                        <Tooltip titleText={'meal_plan'} placement='top-start'>
                            <div className='flex gap-5'>
                                <Icon iconName={commonIcons.MEAL_PLAN} />
                                <p>{supplement.SupplierHotelMealPlan}</p>
                            </div>
                        </Tooltip>
                    </GridChild>
                ) : null}
                {supplement.IdSupplierHotelRatePlan ? (
                    <GridChild gridProps={supplementCardGrid}>
                        <Tooltip titleText={'rate_plan'} placement='top-start'>
                            <div className='flex gap-5'>
                                <Icon iconName={commonIcons.RATE_PLAN} />
                                <p>{supplement.SupplierHotelRatePlan}</p>
                            </div>
                        </Tooltip>
                    </GridChild>
                ) : null}
            </Grid>
        </Card>
    );
};

export default SupplementCard;
